import { render, staticRenderFns } from "./InstructorSchedule.vue?vue&type=template&id=6c71a9c2&scoped=true"
import script from "./InstructorSchedule.vue?vue&type=script&lang=js"
export * from "./InstructorSchedule.vue?vue&type=script&lang=js"
import style0 from "./InstructorSchedule.vue?vue&type=style&index=0&id=6c71a9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71a9c2",
  null
  
)

export default component.exports